import { styled } from "@mui/material";
import MuiAvatar from "@mui/material/Avatar";
import type { AvatarProps as MuiAvatarProps } from "@mui/material/Avatar";
import v2Theme from "components/MuiThemeProvider/theme";

export interface AvatarProps extends MuiAvatarProps {
  size?: "small" | "medium" | "large" | "xlarge";
}

const StyledMuiAvatar = styled(MuiAvatar)(({ theme }) => ({
  backgroundColor: v2Theme.palette.grey[100],
  color: v2Theme.palette.grey[20],
  fontSize: theme.typography.body1.fontSize,
  width: theme.spacing(4),
  height: theme.spacing(4),
  fontWeight: 400,
  textAlign: "center",

  "&.MuiAvatar-root": {
    lineHeight: "23px",
    textTransform: "uppercase",
  },

  "&[data-size='small']": {
    fontSize: "8px",
    width: theme.spacing(2.25),
    height: theme.spacing(2.25),
  },
  "&[data-size='medium']": {
    fontSize: "12px",
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  "&[data-size='large']": {
    fontSize: theme.typography.body1.fontSize,
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  "&[data-size='xlarge']": {
    fontSize: 20,
    fontWeight: 500,
    width: theme.spacing(8),
    height: theme.spacing(8),
  },
}));

function Avatar({ size, ...props }: AvatarProps) {
  return <StyledMuiAvatar className="sr-no-capture" data-size={size} {...props} data-sensitive />;
}

export default Avatar;
